export default {
  WARNING_1: '请输入用户名！',
  WARNING_2: '请输入密码！',
  WARNING_3: '请输入验证码！',
  WARNING_4: '用户名不包含汉字或空格及特殊符号！',
  //   WARNING_5: '请输入6-30位数字,字母及符号~!@#￥$%&*',
  WARNING_5: '8位及以上,包含字母、数字和特殊符号!@#¥$%^&*~\\.,字母区分大小写',
  WARNING_6: '请输入正确的11位手机号码！',
  WARNING_7: '数字字母的组合！',
  WARNING_8: '一天最多可发送五条验证码，请明日再试！',
  WARNING_9: '请选择年级！',
  WARNING_10: '两次输入密码不一致！',
  WARNING_11: '您的密码为初始密码，安全性较低，请及时更改您的登录密码！',
  WARNING_12: '新密码不能和原密码相同！',
  WARNING_13: '图片大小最大为5M！',
  WARNING_14: '图片格式限制为jpg,png！',
  WARNING_15: '没有学期信息，需上级制定完毕后才显示！',
  WARNING_16: '没有学期信息，请录入学期信息！',
  WARNING_17: '请您根据学期的真实情况谨慎填写，学期信息将影响学校工作的顺利开展！',
  WARNING_18: '秋季学期（即上学期）一般在8月份至次年的2月份期间，您确定要保存吗？',
  WARNING_19: '春季学期（即下学期）一般在2月份至次年的8月份期间，您确定要保存吗？',
  WARNING_20: '不同学期之间的时间不能交叉！',
  WARNING_21: '春季学期（即俗称的下学期）的开始时间要在秋季学期（即俗称的上学期）的结束时间基础上至少往后延2周！',
  WARNING_22: '不能连续创建学期类型相同的学期！',
  WARNING_23: '确认删除该学期？',
  WARNING_24: '请仔细确认学期信息是否已制定完毕，制定完毕后将不可更改！',
  WARNING_25: '没有教育局人员信息，请录入或导入人员信息！',
  WARNING_26: '没有符合检索条件的人员！',
  WARNING_27: '你当前做了编辑操作，确认要保存？',
  WARNING_28: '最多只能输入50个字！',
  WARNING_29: '最多只能输入40个字！',
  WARNING_30: '请选择要删除的用户！',
  WARNING_31: '确认删除选择用户账号和密码？',
  WARNING_32: '最多只能输入20个字！',
  WARNING_33: '删除职务将一同删除职务下授权的人员，确认要删除选中的职务吗？',
  WARNING_34: '该职务下存在下级职务，请先删除下级职务！',
  WARNING_35: '最多只能输入200个字！',
  WARNING_36: '在教育厅设置的时间基础上最多往前或往后分别延2周！',
  WARNING_37: '最多只能输入10个字！',
  WARNING_38: '班级名称不能为空！',
  WARNING_39: '请选择班级类型！',
  WARNING_40: '请选择班主任！',
  WARNING_41: '请到“用户信息”菜单下进行用户注册！',
  WARNING_42: '请先在“年级信息”菜单下，为每个年级配置课程！',
  WARNING_43: '请前往教师用户界面进行教师注册！',
  WARNING_44: '没有符合条件的教师！',
  WARNING_45: '确认删除当前教师？',
  WARNING_46: '没有教师信息，请录入或导入教师信息！',
  WARNING_47: '身份证号格式错误！',
  WARNING_48: '没有学生信息，请录入或导入学生信息！',
  WARNING_49: '请选择要删除的学生！',
  WARNING_50: '没有符合检索条件的学生！',
  WARNING_51: '请选择班级！',
  WARNING_52: '请选择要删除的教师！',
  WARNING_53: '确认删除选择教师账号和密码？',
  WARNING_54: '确认删除选择学生账号和密码？',
  WARNING_55: '请选择职务！',
  WARNING_56: '确认删除选择班级？',
  WARNING_57: '没有符合检索条件的字典信息！',
  WARNING_58: '没有符合检索条件的课程信息！',
  WARNING_59: '请先在“学校信息”菜单下，填写当前学校信息！',
  WARNING_60: '请先新增班级！若学期信息未设定当前学期，请先设置学期后在新增班级！',
  WARNING_61: '验证码格式不正确！',
  WARNING_62: '暂无登录日志信息！',
  WARNING_63: '暂无操作日志信息！',
  WARNING_64: '请联系系统管理员，进行系统字典预设维护！',
  WARNING_65: '身份验证失败，请稍候再试！',
  WARNING_66: '请再次输入密码',
  WARNING_67: '您还未新增任何学期，快去新增吧！',
  WARNING_68: '没有学期信息，需上级制定完毕后获取！',
  WARNING_70: '暂无数据！',
  WARNING_71: '最多只能输入30个字！',
  WARNING_72: '班主任选择不能为空！',
  WARNING_73: '请输入原密码！',
  WARNING_74: '请输入新密码！',
  WARNING_75: '请再次输入新密码！',
  WARNING_76: '请选择教师！',
  WARNING_77: '请选择要注册的账号！',
  WARNING_78: '没有符合条件的用户！',
  WARNING_79: '请选择要注册的人员！',
  WARNING_80: '分校未创建年级或未选择年级，无法授权！',
  WARNING_81: '密码格式填写不正确！',
  WARNING_82: '暂无需要注册的用户!',
  WARNING_83: '课程序号格式填写不正确!',
  WARNING_84: '请输入手机号！',
  WARNING_85: '或者信息填写格式不正确！',
  WARNING_86: '操作成功！',
  WARNING_87: '重置密码成功！',
  WARNING_88: '名称不能为空！',
  WARNING_89: '请选择要操作的角色！',
  WARNING_90: '请选择担任班主任的班级！',
  WARNING_91: '请选择任教学科！',
  WARNING_92: '请选择任教学科所在班级！',
  WARNING_93: '该学生已经存在于本校内，无法再转入！',
  NETWORK: '查询异常，请稍后重试！',
  NETWORK_SEND: '请求异常，请稍后重试！',
  FORM_VALID: '必填项不能为空或者填写格式不正确！',
  LOADING: '数据加载中，请稍候！',
  CHINESE_MAX_LENGTH: function CHINESE_MAX_LENGTH(count) {
    return '不能超过' + count + '个汉字的长度！';
  }
};